/**
 * @file paddle 客户案例 案例列表 图标
 * @author FengGuang(fengguang01@baidu.com)
 */
import React from 'react';
import classNames from 'classnames';

interface IIconOrderProps {
    className?: string;
    type?: 'up' | 'down';
}

const IconOrder: React.FC<IIconOrderProps> = props => {

    return (
        <span
            className={classNames(
                props.className,
                'icon-order',
                props.type === 'up' && 'icon-order-up',
                props.type === 'down' && 'icon-order-down'
            )}
        >
            {props.children}
        </span>
    );
};

export default IconOrder;
